export const CONTACT = {
  email: "info@clickphotography.gr",
  whatsappNumber: "+30 699 366 50 29",
  whatsappRaw: "306993665029",
  whatsappLink: "https://wa.me/306993665029",
  telLink: "tel:+306993665029",
  mailLink: "mailto:info@clickphotography.gr",
  instagram: "https://instagram.com/click90photography",
  instagramHandle: "@click90photography",
  facebook: "https://www.facebook.com/click90photography",
  bookingForm: "https://online.forms.app/clickphoto/online-booking-form",
  brandName: "Click Photography",
  brandTagline: "Family · Couples · Elopements",
};

export const BOOKING_QR =
  "https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=10&data=" +
  encodeURIComponent(CONTACT.bookingForm);

// Curated Unsplash imagery — verified on-theme via design agent + Unsplash
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1596249272663-b5a455d0f1b4?auto=format&fit=crop&w=2400&q=80";

// Real Click Photography hero slideshow images
export const HERO_SLIDES = [
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cherished-sessions/artifacts/egkryy3f_DSC_2511.jpg",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cherished-sessions/artifacts/fcqbfgf4_DSC_9853.webp",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cherished-sessions/artifacts/epbba3l2_DSC_6595.jpg",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cherished-sessions/artifacts/0b5leis0_DSC_4536.jpg",
  "https://customer-assets-wrfwihn1.emergentagent.net/job_cherished-sessions/artifacts/h139kcjj_new1_4.jpg",
];

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1641849461096-7e796050f12b?auto=format&fit=crop&w=1600&q=80";

export const GALLERY = [
  // Family
  { src: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1200&q=80", category: "Family", h: "tall" },
  { src: "https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?auto=format&fit=crop&w=1200&q=80", category: "Family", h: "med" },
  // Couples / Elopements
  { src: "https://images.unsplash.com/photo-1706857918275-68df20b51339?auto=format&fit=crop&w=1200&q=80", category: "Couples", h: "tall" },
  // Motherhood
  { src: "https://images.unsplash.com/photo-1565029914917-462bf4980166?auto=format&fit=crop&w=1200&q=80", category: "Motherhood", h: "tall" },
  // Children
  { src: "https://images.unsplash.com/photo-1554342321-0776d282ceac?auto=format&fit=crop&w=1200&q=80", category: "Children", h: "med" },
  // Sunset
  { src: "https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00?auto=format&fit=crop&w=1200&q=80", category: "Sunset", h: "tall" },
];
